import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import {articleRequestSchema} from "../../utils/schemas";
import FormGroup from "../../components/form-group";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import Fileupload from "../../components/files/fileupload";
import Attachment from "../../components/files/attachment";
import {useArticleService} from "../../services/article-service";
import {useBuildingService} from "../../services/building-service";
import {ArticleAttachmentTypes} from "../../utils/constants";
import AddEditAttachmentModal from "../attachment/add-edit-attachment-modal";

const AddEditArticleModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [buildingsList, setBuildingsList] = useState([]);
  const [files, setFiles] = useState([]);
  const [filesData, setFilesData] = useState([]);
    const [reset, setReset] = useState(0);

  let formSchema = articleRequestSchema;

  const addEditAttachmentModal = useRef();

  let articleService = useArticleService();
  let buildingService = useBuildingService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null, buildingId=null) => {
    setLoading(true);
    setFiles([]);

    let promises = [
     Promise.resolve('initOk'),
     Promise.resolve(buildingService.getList())
    ];

    if (model && model.id){
      promises.push(getDetail(model.id));
    }

    Promise.all(promises).then(([init=null, buildings=[], detail= {}])=>{
      setBuildingsList(buildings);

      let newDetail = Object.assign({}, {building_id: buildingId ? buildingId : ''}, detail);
      setModel(formSchema.cast(newDetail));
      setLoading(false);
    });

    setShow(true);
  }
  const closeModal = () => {
    setShow(false);
    setReset(reset+1);
    setModel(formSchema.cast());
  }

  const getDetail = (id) => {
    return articleService.getDetail(id);
  }

  const onAttachmentDelete = (item)=>{
    setModel((model)=>{
      let m = model;
      m.attachments = [...HelperService.removeItemFromList(m.attachments, item)];
      return Object.assign({}, m);
    })
  };

  const onAddEditAttachmentCallback = (item)=>{
    setModel((model)=>{
      let m = model;
      m.attachments = [...HelperService.addOrReplaceItemInList(m.attachments, item)];
      return Object.assign({}, m);
    })
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    let reqValues = {...values};
    if (files && files.length){
      reqValues.files = files;
    }

    articleService.addEditModel(reqValues, reqValues.id)
      .then((res) => {
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        setFiles([]);
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{ setSubmitting(false);});
  };

  return (

      <Formik
          key={reset}
          enableReinitialize={true}
          initialValues={formSchema.cast(model) || formSchema.cast()}
          validationSchema={formSchema}
          onSubmit={onSubmit}
          validateOnChange={false}
      >
        {({ isSubmitting, errors, touched, handleSubmit, setFieldValue, values}) => (

            <Modal size="lg" show={!!show} onHide={closeModal} centered>
              <Modal.Header closeButton>
                { model && <Modal.Title>{ !model.id ? 'Nový článok' : 'Úprava článku' }</Modal.Title>}
              </Modal.Header>
              <Modal.Body>
                <Section animation={HelperService.getRandomAnimation()}>

                  {loading && <Loading className="m-2" />}

                  {!loading && <Form className="row">

                    <AddEditAttachmentModal ref={addEditAttachmentModal} onSuccess={(item)=>onAddEditAttachmentCallback(item)} />

                    <FormGroup
                        name="title"
                        placeholder="Názov"
                        label="Názov"
                        className="col-md-4"
                        touched={touched} errors={errors} schema={formSchema}
                    />

                    <FormGroup
                        name="building_id"
                        type="select"
                        options={buildingsList}
                        optionLabel="title"
                        optionKey="id"
                        placeholder="Budova"
                        label="Budova"
                        className="col-md-4"
                        touched={touched} errors={errors} schema={formSchema}
                    />

                    <FormGroup
                        type="checkbox"
                        name="is_published"
                        placeholder="Publikovaný"
                        label="Publikovaný"
                        className="col-md-4"
                        touched={touched} errors={errors} schema={formSchema}
                    />

                    <div className={'clearfix'}></div>

                    <FormGroup
                        name="published_from"
                        type="date"
                        placeholder="Publikovať od"
                        label="Publikovať od"
                        className="col-md-4"
                        touched={touched} errors={errors} schema={formSchema}
                    />

                    <FormGroup
                        name="published_to"
                        type="date"
                        placeholder="Publikovať do"
                        label="Publikovať do"
                        className="col-md-4"
                        touched={touched} errors={errors} schema={formSchema}
                    />

                    <FormGroup
                        type="textarea"
                        name="short_text"
                        placeholder="Krátky text"
                        label="Krátky text"
                        className="col-md-12"
                        touched={touched} errors={errors} schema={formSchema}
                    />

                    <FormGroup
                        type="editor"
                        name="article"
                        placeholder="Text článku"
                        label="Text článku"
                        className="col-md-12"
                        touched={touched} errors={errors} schema={formSchema}
                    />

                    <div className="col-sm-12" key="mediadocsection">
                      <h5>Médiá a dokumenty</h5>
                      <p className='text-muted'>Pridajte hlavný obrázok, galériu k článku alebo dokumenty na stiahnutie.</p>
                      <Fileupload attachmentTypes={Object.values(ArticleAttachmentTypes)}
                                  files={files}
                                  filesData={filesData}
                                  onChange={({files, filesData})=>{setFiles(files); setFilesData(filesData)}}
                                  setFieldValue={setFieldValue} />
                    </div>

                    <div className="clearfix"></div>

                  </Form>}

                  {model?.attachments && model?.attachments?.length>0 && <div className="row mt-2">
                    {model.attachments.map((att)=>{
                      return <div key={'att_wrap_'+att.id} className="col-12">
                        <Attachment attachment={att}
                                    gallery={false}
                                    onDelSuccess={(att)=>onAttachmentDelete(att)}
                                    editAction={(att)=>addEditAttachmentModal.current.openModal(att, Object.values(ArticleAttachmentTypes))}
                        />
                      </div>;
                    })}
                  </div>}

                </Section>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
                <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
              </Modal.Footer>
            </Modal>
        )}
      </Formik>
  );
});

export default React.memo(AddEditArticleModal);
